import React, { useState, useEffect } from "react";
import Select from "react-select";

const getDefaultStyles = (isMobile) => ({
  control: (provided, state) => ({
    ...provided,
    width: isMobile ? '100%' : '400px',
    height: '40px',
    minHeight: '40px',
    border: '1px solid #0000005C',
    borderRadius: '8px',
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    paddingLeft: '12px',
    backgroundColor: 'white',
    color: '#212121D9',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(95, 77, 199, 0.2)' : 'none',
    borderColor: state.isFocused ? '#5f4dc7' : '#0000005C',
    '&:hover': {
      borderColor: state.isFocused ? '#5f4dc7' : '#0000005C'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 0 0 0',
    height: '38px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3b3b3',
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#212121D9',
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px'
  }),
  menu: (provided) => ({
    ...provided,
    fontFamily: '"Poppins", sans-serif',
    width: isMobile ? '100%' : '400px'
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: '"Poppins", sans-serif',
    fontSize: '14px',
    padding: '8px 12px',
    backgroundColor: state.isSelected ? '#5f4dc7' : 'white',
    color: state.isSelected ? 'white' : '#212121D9',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: state.isSelected ? '#5f4dc7' : '#f0f0f0'
    }
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#0000005C',
    '&:hover': {
      color: '#0000005C'
    }
  })
});
const ReactSelect = ({
  title,
  placeholder,
  value,
  onChange,
  options,
  textColor,
  fontSize,
  fontWeight,
  isShow = true,
  styles: customStyles = {},
  labelStyles = {},
  ...props
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const defaultStyles = getDefaultStyles(isMobile);

  // Merge custom styles with default styles
  const mergedStyles = Object.keys(defaultStyles).reduce((acc, key) => {
    acc[key] = (provided, state) => {
      const defaultStyle = typeof defaultStyles[key] === 'function'
        ? defaultStyles[key](provided, state)
        : defaultStyles[key];

      const customStyle = customStyles[key]
        ? (typeof customStyles[key] === 'function'
          ? customStyles[key](provided, state)
          : customStyles[key])
        : {};

      return { ...defaultStyle, ...customStyle };
    };
    return acc;
  }, {});

  return (
    <div>
      {title && (
        <div style={{
          color: labelStyles.color || '#212121D9',
          marginBottom: labelStyles.marginBottom || '4px',
          paddingLeft: labelStyles.paddingLeft || '4px',
          fontFamily: labelStyles.fontFamily || '"Poppins", sans-serif',
          fontWeight: labelStyles.fontWeight || '500',
          fontSize: labelStyles.fontSize || '12px',
          lineHeight: labelStyles.lineHeight || '24px',
          letterSpacing: labelStyles.letterSpacing || '0.1px',
        }}>
          {title}
          {isShow && <span style={{ color: textColor ? textColor : '#212121D9' }}>*</span>}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isClearable
        styles={mergedStyles}
        isSearchable={false}
        blurInputOnSelect={true}
        openMenuOnFocus={false}
        {...props}
      />
    </div>
  );
};

export default ReactSelect;